export * from './ResourceDetailsHeader';
